import { render } from "./IconElectraWeightCapacity.vue?vue&type=template&id=6613a8f8"
import script from "./IconElectraWeightCapacity.vue?vue&type=script&lang=js"
export * from "./IconElectraWeightCapacity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__